import { Component, OnInit } from '@angular/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { ActivatedRoute, Router } from '@angular/router'
import { AccountService } from '@core/services'
import { TabsConst } from '@rush-shared/constants'
import { RushMainService } from '@rush-shared/services'
import { RouteManagerService } from '@shared/services'

@Component({
  selector: 'app-third-party-auth',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './third-party-auth.component.html',
  styleUrl: './third-party-auth.component.sass',
})
export class ThirdAuthComponent implements OnInit {
  constructor(
    private _accountService: AccountService,
    private _activatedRoute: ActivatedRoute,
    private _routeManagerService: RouteManagerService,
    private _router: Router,
    private _rushMainService: RushMainService,
  ) {}

  private readonly username = this._activatedRoute.snapshot.paramMap.get('username') as string
  private readonly platformName = this._activatedRoute.snapshot.paramMap.get(
    'platformName',
  ) as string
  private readonly userToken = this._activatedRoute.snapshot.paramMap.get('userToken') as string
  private readonly sign = this._activatedRoute.snapshot.paramMap.get('sign') as string
  private readonly gameType = this._activatedRoute.snapshot.paramMap.get('gameType') as string
  private readonly returnUrl = this._activatedRoute.snapshot.queryParamMap.get(
    'returnUrl',
  ) as string

  ngOnInit(): void {
    const selectedTab = TabsConst.find((tab) => tab.name === this.gameType)

    if (localStorage.getItem('username') === this.username) {
      this._routeManagerService.redirect()

      return
    }

    if (selectedTab) this._rushMainService.setActiveTab(selectedTab)
    this._accountService
      .thirdPartyUserAuth(this.username, this.userToken, this.sign, this.platformName, this.gameType)
      .subscribe({
        next: () => {
          this._routeManagerService.setReturnUrl(this.returnUrl)
          this._routeManagerService.redirect()
        },
        error: (i) => {
          this._router.navigate(['/error', i.status])

          console.log(i)
        },
      })
  }
}
